module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M22 2c0-1.106-.894-2-2-2H8C6.894 0 6 .894 6 2v4H2C.894 6 0 6.894 0 8c0 1.106.894 2 2 2v20c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V10c1.106 0 2-.894 2-2 0-1.106-.894-2-2-2h-4V2zM10 4h8v2h-8V4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trash-1.js
// module id = 1455
// module chunks = 14